"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function createCodeMirror({ codeMirrorConstructor, language, node, placeholder, value, }) {
    const tabSize = language === 'python' ? 4 : 2;
    const options = {
        extraKeys: {
            Tab: function (cm) {
                if (cm.getSelections().some(Boolean)) {
                    cm.execCommand('defaultTab');
                }
                else {
                    cm.execCommand('insertSoftTab');
                }
            },
            'Shift-Tab': function (cm) {
                cm.execCommand('indentLess');
            },
        },
        indentUnit: tabSize,
        indentWithTabs: false,
        lineWrapping: true,
        mode: language,
        placeholder,
        readOnly: false,
        tabIndex: '0',
        tabSize,
        value,
    };
    return codeMirrorConstructor(node, options);
}
exports.default = createCodeMirror;
